import React from 'react';

import config from '../../config';

export default function Footer() {
  return (
    <header>
      <span className="avatar">
        <img height="128px" src="https://avatars1.githubusercontent.com/u/3521238" alt="" />
      </span>
      <h1>{config.authorName}</h1>
      <p>{config.heading}</p>
    </header>
  );
}
